// Tenant isolation gate: children are rendered only when the school data in
// the store (scuolaReducer) belongs to the tenant in the URL. Persisted state
// can belong to a different school, so we detect that, clear it, and reload
// the school data before any page component mounts.
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";
import { clearAppData, setSlug, setLang } from "../../redux/actions/appActions";
import { loadSchoolData } from "../../redux/actions/scuolaActions";

const up = (s) => (s ?? "").toString().toUpperCase();
const matchesTenant = (dati, cod) =>
  !!dati &&
  (up(dati.codiceScuola) === up(cod) ||
    (!!dati.slug && up(dati.slug) === up(cod)));

function SchoolGate({ codScuola, lang, children }) {
  const dispatch = useDispatch();
  const dati = useSelector((s) => s.scuolaReducer);
  const appSlug = useSelector((s) => s.appReducer?.slug);

  const ready = matchesTenant(dati, codScuola);
  const upCod = up(codScuola);
  const upLang = up(lang);

  useEffect(() => {
    // Clear only on evidence of a different tenant: clearing also empties the
    // cart, which must survive e.g. a bank redirect with expired school data.
    const otherTenant =
      (dati?.codiceScuola && !matchesTenant(dati, codScuola)) ||
      (appSlug && up(appSlug) !== upCod);
    if (otherTenant) {
      dispatch(clearAppData());
    }
    dispatch(setSlug(upCod));
    dispatch(setLang(upLang));
    dispatch(loadSchoolData(codScuola, lang)).catch((e) => console.error(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upCod, upLang]);

  return ready ? <>{children}</> : <Loader active />;
}

export default SchoolGate;
